'use client'

import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import { useCustomDataPageStore } from '@repo/store/useCustomDataPageStore'

export const CustomDataPageSelect = ({
  testData = null,
  value = null,
  onChange = (val) => console.log(val),
  sx,
  size = 'small',
  required,
  errors = {},
  workflowTypeId
}) => {
  const { fetchCustomDataPages, customDataPagesByWorktype } = useCustomDataPageStore()
  const [options, setOptions] = useState(testData || customDataPagesByWorktype || [])

  useEffect(() => {
    if (testData) return
    setOptions(customDataPagesByWorktype[workflowTypeId] || [])
  }, [testData, workflowTypeId, customDataPagesByWorktype])

  useEffect(() => {
    if (testData) return
    fetchCustomDataPages({ workflowTypeId })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testData, customDataPagesByWorktype])

  return (
    <div data-testid="CustomDataPageSelect" style={{ width: sx?.width || '100%', maxWidth: sx?.maxWidth || '100%' }}>
      <ReactSelectMenu
        label="Custom data page"
        onChange={onChange}
        labelKey="description"
        valueKey="customDataPageId"
        items={options}
        value={value}
        searchable
        idLabelKey="customDataPageId"
        showIdInResults={true}
        name="customDataPage"
        size={size}
        required={required}
        errors={errors}
      />
    </div>
  )
}

CustomDataPageSelect.propTypes = {
  testData: PropTypes.array,
  value: PropTypes.object,
  onChange: PropTypes.func,
  sx: PropTypes.object,
  size: PropTypes.string,
  required: PropTypes.bool,
  errors: PropTypes.object,
  workflowTypeId: PropTypes.string
}
